const eventEmitter = {
  events: {},
  subscribe: function (event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  },
  emit: function (event, data) {
    if (this.events[event]) {
      this.events[event].forEach((listener) => listener(data));
    }
  },
};

export const urtoast = (message, type, time) => {
  eventEmitter.emit("notification", { message, type, time });
};

export default eventEmitter;
